import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useCreateProjectMutation,
  useUploadPDFFileMutation,
} from "../../actions/homeAction";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [timeLeft, setTimeLeft] = useState(null);
  const [cancelUpload, setCancelUpload] = useState(null);
  const [uploadedPDFFileURL, setUploadedPDFFileURL] = useState(null);
  const [imageUrls, setImageUrls] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadPDFFileRe, setUploadPDFFileRe] = useState("");
  const [loadingToapi, setLoadingToapi] = useState(false);
  const { TextWeight } = textWeight();
  const { handleSubmit } = useForm({
    defaultValues: {
      pdf: "",
    },
  });

  const createProjectMutation = useCreateProjectMutation(
    setLoadingToapi,
    uploadedPDFFileURL,
    loadingToapi,
    setShowPopup
  );

  const uploadPDFFileMutation = useUploadPDFFileMutation(
    setCancelUpload,
    setUploadProgress,
    setTimeLeft,
    setLoadingToapi,
    setImageUrls,
    setUploadedPDFFileURL,
    setUploadPDFFileRe
  );

  const onChangeImage = (file) => {
    if (file) {
      setFileName(file.name);
      setFileSize((file.size / (1024 * 1024)).toFixed(2) + " MB");
      const formData = new FormData();
      formData.append("pdf", file);
      setUploadedPDFFileURL(null);
      uploadPDFFileMutation.mutate(formData);
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setErrorMessage("");
      onChangeImage(file);
    } else {
      setErrorMessage("Please upload a PDF file.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    setErrorMessage(""); // Reset error message
    const file = e.dataTransfer.files[0];
    // Check if file is a PDF
    if (file && file.type === "application/pdf") {
      onChangeImage(file); // Handle PDF file upload here
    } else {
      setErrorMessage("Please upload a PDF file."); // Set error message
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving the drop area
  };
  const serviceId = useSelector((state) => state.app.serviceId.serviceId);
  const parentId = useSelector((state) => state.app.categoryData.categoryData);
  const subCategoryIds = useSelector((state) => state.app.subCategoryIds);

  const onSubmitProfile = () => {
    setLoadingToapi(true);
    const projectData = {
      name: parentId.projectName,
      pdf: uploadedPDFFileURL,
      images: imageUrls,
      service: serviceId,
      category: parentId.categoryId,
      subCategory:
        typeof subCategoryIds?.subCategoryIds === "string"
          ? subCategoryIds.subCategoryIds
          : null,
    };

    createProjectMutation.mutate(projectData);
  };

  const handleDelete = () => {
    if (cancelUpload) {
      cancelUpload();
    }
    setUploadProgress(0);
    setTimeLeft(null);
    setUploadedPDFFileURL(null);
    setCancelUpload(null);
    fileInputRef.current.value = "";
    setFileName("");
    setFileSize("");
  };
  function formatTimeLeft(timeLeft) {
    if (timeLeft >= 3600) {
      // If more than or equal to 1 hour
      const hours = Math.floor(timeLeft / 3600);
      const minutes = Math.floor((timeLeft % 3600) / 60);
      return `${hours} hour${hours > 1 ? "s" : ""}${
        minutes > 0 ? ` ${minutes} min` : ""
      } left`;
    } else if (timeLeft >= 60) {
      // If more than or equal to 1 minute
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      return `${minutes} min${minutes > 1 ? "s" : ""}${
        seconds > 0 ? ` ${seconds} sec` : ""
      } left`;
    } else {
      // Less than a minute
      return `${timeLeft} sec left`;
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(onSubmitProfile)(e);
  };

  return {
    navigate,
    handleFormSubmit,
    isDragging,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    fileInputRef,
    handleFileInputChange,
    errorMessage,
    fileName,
    uploadedPDFFileURL,
    fileSize,
    uploadProgress,
    timeLeft,
    formatTimeLeft,
    handleDelete,
    showPopup,
    loadingToapi,
    uploadPDFFileRe,
    TextWeight,
  };
};
